/* V161 — FooterLiveCounter — real-time social proof for footer.
   Renders pod brand intro v LandingFooter. Pollls /api/footer/live-stats
   every 30s. Animated pulse dot + comma-formatted numbers.
*/
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../config";

export default function FooterLiveCounter() {
  const [data, setData] = useState(null);
  const [pulseKey, setPulseKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      axios
        .get(`${API}/footer/live-stats`)
        .then((r) => {
          if (cancelled) return;
          setData(r.data);
          setPulseKey((k) => k + 1);
        })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 30_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!data) {
    return (
      <div className="mt-4 text-[10px] text-zinc-700 font-['JetBrains_Mono']" data-testid="footer-live-loading">
        Loading live stats...
      </div>
    );
  }

  return (
    <div
      key={pulseKey}
      className="mt-4 space-y-2"
      data-testid="footer-live-counter"
    >
      <div className="flex items-center gap-2 text-[11px]">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        <span className="font-['JetBrains_Mono'] uppercase tracking-wider text-emerald-400 font-bold">
          LIVE
        </span>
      </div>

      <div className="text-xs text-[var(--color-text-muted)] leading-relaxed">
        <span className="font-black text-white" data-testid="footer-eshops-active">
          {data.eshops_active.toLocaleString("sk-SK")}
        </span>{" "}
        e-shopov práve používa našich agentov.
      </div>

      <div className="text-xs text-[var(--color-text-muted)] leading-relaxed">
        <span className="font-black text-emerald-400" data-testid="footer-saved-eur">
          €{Math.round(data.saved_eur_week).toLocaleString("sk-SK")}
        </span>{" "}
        ušetrené tento týždeň.
      </div>

      <div className="text-[10px] text-zinc-600 font-['JetBrains_Mono']">
        🟢 {data.online_now.toLocaleString("sk-SK")} online · refresh každých 30s
      </div>
    </div>
  );
}
